import styled from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import InputSimple, { phoneDecorator, nameDecorator } from '@ertelecom/ui-react/components/inputSimple';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

export const Wrapper = styled.form`
    display: block;
    position: relative;
    z-index: 1;
    max-width: 694px;
    margin-bottom: 160px;
    margin-top: 100px;
    @media (max-width: 530px) {
        margin-top: 60px;
    }
`;

export const Title = styled.h2`
    display: block;
    ${FONTS.H2};
    margin-bottom: 30px;
    @media (max-width: 1279px) {
        margin-right: 20px;
        margin-bottom: 24px;
    }
    @media screen and (max-width: 859px) {
        ${FONTS.H3};
    }
    @media (max-width: 530px) {
        ${FONTS.H4};
    }
`;

export const Description = styled.p`
    display: block;
    ${FONTS.XXL};
    margin-bottom: 16px;
    @media (max-width: 1279px) {
        ${FONTS.L};
        margin-bottom: 12px;
    }
    @media (max-width: 530px) {
        ${FONTS.XXS};
    }
`;

export const Inputs = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 16px;
    @media (max-width: 360px) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

export const Name = styled(InputName)`
    display: block;
    width: calc(50% - 10px);
    margin-right: 20px;
    @media (max-width: 1279px) {
        margin-right: 8px;
        width: calc(50% - 4px);
    }
    @media (max-width: 530px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 16px;
    }
`;

export const Phone = styled(InputPhone)`
    display: block;
    width: calc(50% - 10px);
    @media (max-width: 1279px) {
        width: calc(50% - 4px);
    }
    @media (max-width: 530px) {
        width: 100%;
        margin-bottom: 16px;
    }
`;
export const ButtonBlock = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
    @media (max-width: 530px) {
        margin-bottom: 24px;
    }
`;

export const Agree = styled.div`
    display: block;
    width: calc(100% - 308px);
    padding-left: 21px;
    ${FONTS.XS};
    color: ${COLORS.darkGrey};
    a {    
        display: inline-block;
        border-bottom: 1px solid ${COLORS.darkGrey};
        color: ${COLORS.darkGrey};
    }
    @media (max-width: 1279px) {
        width: calc(100% - 254px);
    }
    @media (max-width: 576px) {
        width: 100%;
        padding-left: 0;
    }
`;

export const Button = styled(StyledButton)`
    display: block;
    width: 308px;
    @media (max-width: 1279px) {
        width: 254px;
    }
    @media (max-width: 576px) {
        width: 100%;
        margin-bottom: 10px;
    }
`;

export const Message = styled.div`
    display: block;
    width: 100%;
    ${FONTS.XXL};
    p {
        margin: 15px 0;
    }
    a {
        ${FONTS.Medium};
        color: ${COLORS.lightBlue};
    }
`;
